const validatorRules = {
  password: {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/~])/,
    minLength: 8,
    maxLength: 16,
  },
};

export const validatorRulesForCurrentPassword = {
  password: {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
    minLength: 8,
    maxLength: 16,
  },
};

export default validatorRules;
